import { z } from 'zod';

import { FieldTypes } from '@features/campaigns/builder/components/FormFields/FieldTypes.ts';
import { MAX_NUMBER_OF_CREATIVES, MIN_NUMBER_OF_CREATIVES } from '@features/campaigns/builder/consts/common.ts';

interface ValidatorValues {
  [FieldTypes.FORMAT_TYPE_DISPLAY]?: boolean;
  [FieldTypes.IS_CREATIVE_SERVICES_FULL]?: boolean;
  [FieldTypes.NUMBER_OF_CREATIVES]?: number;
}
export function numberOfCreativesValidationCheck(
  { formatTypeDisplay, isCreativeServicesFull, numberOfCreatives }: ValidatorValues,
  ctx: z.RefinementCtx,
) {
  const allDependantFieldsAreValid =
    formatTypeDisplay && isCreativeServicesFull && typeof numberOfCreatives === 'number';

  if (allDependantFieldsAreValid && numberOfCreatives < MIN_NUMBER_OF_CREATIVES) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'errorMessages.numberOfCreativesMinValue',
      path: [FieldTypes.NUMBER_OF_CREATIVES],
    });
  }

  if (allDependantFieldsAreValid && numberOfCreatives > MAX_NUMBER_OF_CREATIVES) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'errorMessages.numberOfCreativesMaxValue',
      path: [FieldTypes.NUMBER_OF_CREATIVES],
    });
  }
}
